import DatePicker from 'components/DatePicker';
import { isValid } from 'date-fns';
import parseISO from 'date-fns/parseISO';
import React from 'react';

const CSS = require('./DateInput.module.scss');

const isValidDate = (dateString: string): string | null => {
  const parsedDate = parseISO(dateString);

  if (isValid(parsedDate)) {
    return dateString;
  } else {
    return null;
  }
};

function DateInput({ defaultValue }: { defaultValue?: string }) {
  const [selectedDate, setSelectedDate] = React.useState<string | null>(
    isValidDate(defaultValue),
  );
  const onDateChange = (newDate) => {
    setSelectedDate(newDate);
  };
  return (
    <div className={CSS.DateInputContainer}>
      <DatePicker selectedDate={selectedDate} onDateChange={onDateChange} />
      <input hidden name="date" value={selectedDate} />
    </div>
  );
}

export default DateInput;
